import React from "react";
import { AllComputeCreationActions } from "./ComputeCreationActions";

const EnvironmentListHeader: React.FC<{
  isAdmin: boolean;
  onAddCloud: () => void;
}> = ({ isAdmin, onAddCloud }) => (
  <header className="mb-8 flex flex-wrap items-end justify-between gap-5">
    <div className="max-w-2xl">
      <h1 className="mb-4 text-2xl font-semibold text-white">Compute</h1>
      <p className="text-sm leading-6 text-secondary">
        Manage cloud and local compute available to your organization.
      </p>
    </div>
    <div className="flex items-center gap-3">
      <AllComputeCreationActions isAdmin={isAdmin} onAddCloud={onAddCloud} />
    </div>
  </header>
);

export default EnvironmentListHeader;
